import { render, staticRenderFns } from "./SendActionMore.vue?vue&type=template&id=523bcd3d&scoped=true&"
import script from "./SendActionMore.vue?vue&type=script&lang=js&"
export * from "./SendActionMore.vue?vue&type=script&lang=js&"
import style0 from "./SendActionMore.vue?vue&type=style&index=0&id=523bcd3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523bcd3d",
  null
  
)

export default component.exports